import { FunctionComponent } from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";

const NotAuthorised: FunctionComponent = () => {
  return (
    <Container>
      <Row>
        <Col>
          <h1>Not Authorised</h1>
          <p>You do not have the required permissions to view this page</p>
        </Col>
      </Row>
    </Container>
  );
};

export default NotAuthorised;
